/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    parts: ['container', 'icon', 'link', 'bcText', 'bcTextLast', 'lastLink'],
    baseStyle: () => ({
        container: {
            textStyle: 'bodyXsRegular',
            fontSize: 'xs',
            marginTop: [2, 2, 3, 3, 3],
            '& [role="presentation"]': {
                color: 'webTypo.textSecondary'
            }
        },
        icon: {
            display: 'flex',
            boxSize: 4,
            color: 'grey.700'
        },
        link: {
            textStyle: 'bodyXsRegular',
            display: 'flex',
            alignItems: 'center'
        },
        bcText: {
            color: 'webTypo.textSecondary',
            textStyle: 'bodyXsRegular',
        },
        lastLink: {
            pointerEvents: 'none',
            _hover: {
                textDecoration: 'none'
            }
        },
        bcTextLast: {
            color: 'webTypo.textPrimary',
            textStyle: 'bodyXsRegular'
        }
    }),
    variants: {
        pdp: {
            container: {
                margin: {base: 'none', lg: '8px 0'}
            },
            lastLink: {
                pointerEvents: 'auto',
                color: 'webTypo.textSecondary',
                _hover: {
                    textDecoration: 'underline'
                }
            }
        },
        plp: {
            container: {
                margin: {base: '0 8px', lg: '0'}
            }
        }
    }
}
